import React from "react";
import { Link } from "react-router-dom";

export const Header: React.FC = () => {
  const logoPath = process.env.REACT_APP_LOGO_PATH || "/assets/alejandro/logo.png";

  return (
    <header className="bg-white shadow-md w-full fixed top-0 z-10">
      <Link to='/register' className="container mx-auto p-2 flex justify-center items-center">
        <img src={logoPath} alt="Campaign Logo" className="h-16" />
      </Link>
    </header>
  );
};
